export default __webpack_public_path__ + "static/media/screen_telegram_2.d32b99c3.png";